import { useTranslate } from '@tolgee/react';
import { Button } from 'antd';
import { Empty } from 'antd';
import { useTransAppProductName } from 'hooks/useTrans';

interface ChatErrorResultProps {
  reset: () => void;
  onReset?: () => void;
}

export const ChatErrorResult = ({ reset, onReset }: ChatErrorResultProps) => {
  const { t } = useTranslate();
  const appProductNameT = useTransAppProductName();

  return (
    <Empty className="flex-grow shrink-[3] basis-1/2" description="">
      <div className="text-[var(--fett-text-secondary)]">
        {t('common.feedback.loadFailedRetry')}
      </div>
      <div className="text-[var(--fett-text-tertiary)] mt-1 mb-4">
        {appProductNameT('ViewsChat.retryFailedContactMsg')}
      </div>
      <Button
        type="primary"
        onClick={() => {
          reset();
          onReset?.();
        }}
      >
        {t('common.action.reload')}
      </Button>
    </Empty>
  );
};
